<div class="hidden-sm">
  <div
    class="card card-m card-border-1 full-width mb-24"
    *ngIf="(subjects$ | async)?.length"
  >
    <div class="card-body">
      <div
        class="typography typography-headline typography-paragraph typography-bold black"
      >
        Описание {{ isAnalyse ? "анализа" : "статьи" }}
      </div>

      <div class="relative">
        <div
          class="anchor anchor-s max-h-240 scrollable-y"
          #anchorContainer
          di-overscrollY
        >
          <div
            *ngFor="
              let subject of subjects$ | async;
              let i = index;
              trackBy: trackBy
            "
            #subject
            class="anchor-link"
            [class.active]="(repository.activeSubject$ | async) === i"
            (click)="setSubjectId(i)"
          >
            {{ subject }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
